import React, { useRef } from 'react';
import Typography from '@material-ui/core/Typography';
import { FormattedMessage } from 'react-intl';
import { FindMoreButton } from '../../pages/Home/HomeFeatures/FindMoreButton';
import { makeStyles } from '@material-ui/core/styles';
import { COLORS2 } from '../../constants.js';
import XRContentDialog from './XRContentDialog.js';

const TAG_MOUNTAIN = 'orange.tag.mountains';
const TAG_CARPATHIANS = 'orange.tag.carpathians';
const TAG_GEOGRAPHY = 'orange.tag.geography';
const TAG_COUNTY = 'orange.tag.county';
const TAG_ROMANIA = 'orange.tag.romania';
const TAG_CAVE = 'orange.tag.cave';
const TAG_SFINX = 'orange.tag.sfinx';
const CLASS_VIII = 'orange.class.VIII';

const XR_RESOURCE_LIST = [
    { id: 2, tags: [TAG_CARPATHIANS, TAG_MOUNTAIN], classId: CLASS_VIII },
    { id: 3, tags: [TAG_CARPATHIANS, TAG_MOUNTAIN], classId: CLASS_VIII },
    { id: 4, tags: [TAG_CARPATHIANS, TAG_MOUNTAIN], classId: CLASS_VIII },
    { id: 5, tags: [TAG_CARPATHIANS, TAG_MOUNTAIN], classId: CLASS_VIII },
    { id: 7, tags: [TAG_GEOGRAPHY, TAG_MOUNTAIN], classId: CLASS_VIII },
    { id: 8, tags: [TAG_SFINX], classId: CLASS_VIII },
    { id: 9, tags: [TAG_CAVE], classId: CLASS_VIII },
    { id: 10, tags: [TAG_CAVE], classId: CLASS_VIII },
    { id: 11, tags: [TAG_CAVE], classId: CLASS_VIII },
    { id: 12, tags: [TAG_CAVE], classId: CLASS_VIII },
    { id: 13, tags: [TAG_CAVE], classId: CLASS_VIII },
    { id: 14, tags: [TAG_CAVE], classId: CLASS_VIII },
    { id: 15, tags: [TAG_GEOGRAPHY, TAG_MOUNTAIN], classId: CLASS_VIII },
    { id: 16, tags: [TAG_GEOGRAPHY, TAG_ROMANIA], classId: CLASS_VIII },
    { id: 21, tags: [TAG_GEOGRAPHY, TAG_MOUNTAIN], classId: CLASS_VIII },
    { id: 22, tags: [TAG_GEOGRAPHY, TAG_MOUNTAIN], classId: CLASS_VIII },
    { id: 23, tags: [TAG_GEOGRAPHY, TAG_COUNTY], classId: CLASS_VIII },
    { id: 24, tags: [TAG_GEOGRAPHY, TAG_COUNTY], classId: CLASS_VIII },
    { id: 25, tags: [TAG_GEOGRAPHY, TAG_COUNTY], classId: CLASS_VIII },
    { id: 26, tags: [TAG_GEOGRAPHY, TAG_COUNTY], classId: CLASS_VIII },
    { id: 27, tags: [TAG_GEOGRAPHY, TAG_COUNTY], classId: CLASS_VIII },
    { id: 28, tags: [TAG_GEOGRAPHY, TAG_MOUNTAIN], classId: CLASS_VIII },
    { id: 29, tags: [TAG_GEOGRAPHY, TAG_MOUNTAIN], classId: CLASS_VIII },
    { id: 30, tags: [TAG_GEOGRAPHY, TAG_MOUNTAIN], classId: CLASS_VIII },
    { id: 31, tags: [TAG_GEOGRAPHY, TAG_MOUNTAIN], classId: CLASS_VIII },
];


const useStyles = makeStyles(() => ({
    mainContent: {
        marginTop: '2rem',
    },
    cardContent: {
        display: 'flex',
        flexWrap: 'wrap',
        cursor: 'pointer',
    },
    card: {
        borderRadius: '1rem 1rem 1rem 1rem',
        background: '#FFF',
        boxShadow: '0rem 0rem 2.5rem rgba(210, 104, 40, 0.04)',
        padding: '0.5rem',
        margin: '0.3rem',
        position: 'relative',
        maxWidth: '20rem',
        paddingBottom: '2rem',
    },
    cardTitle: {
        color: COLORS2.virtualAmber,
    },
    classTitle: {
        color: COLORS2.primaryD2,
    },
    cardTarget: {
        display: 'flex',
        flexWrap: 'wrap',
        position: 'absolute',
        bottom: '0.3rem',
    },
    cardTag: {
        borderRadius: '0.5rem 0.5rem 0.5rem 0.5rem',
        background: COLORS2.primaryL1,
        boxShadow: '0rem 0rem 2.5rem rgba(210, 104, 40, 0.04)',
        padding: '0.3rem',
        margin: '0.3rem',
        fontSize: '0.8rem',
        fontWeight: '600',
    },
}));


const OrangeXRContent = () => {
    const classes = useStyles();
    let xrContentRef = useRef(React.createRef());
    return (<div className={classes.mainContent}>
        <Typography variant='h5'>
            <FormattedMessage id='orange.xrContentTitle' />
        </Typography>
        <a href='https://ghid.platformadigitaliada.ro/resurse-xr/' target='_blank' rel={'noopener'}>
            <FindMoreButton textId={'orange.xrLinkDescription'} />
        </a>
        <div className={classes.cardContent}>
            {XR_RESOURCE_LIST.map(el => {
                return (
                    <div className={classes.card} key={`orangeXR-item-${el.id}`} onClick={() => {
                        window.open(`https://www.platformadigitaliada.ro/xr/${el.id}/view`, '_blank');
                        // xrContentRef.current.openXRPage(el.id);
                    }}>
                        <h5 className={classes.cardTitle}><FormattedMessage
                            id={`orange.xr.${el.id}.title`} /></h5>
                        <h6 className={classes.classTitle}><FormattedMessage
                            id={el.classId} /></h6>
                        <h6><FormattedMessage id={`orange.xr.${el.id}.description`} /></h6>
                        <div className={classes.cardTarget}>
                            {el.tags.map((tg, idx) => {
                                return (<div className={classes.cardTag} key={`tag-${el.id}-${idx}`}><FormattedMessage
                                    id={tg} /></div>);
                            })}
                        </div>
                    </div>
                );

            })}
            <XRContentDialog ref={xrContentRef} />
        </div>
    </div>);
};

export default OrangeXRContent;